export default "__VITE_PUBLIC_ASSET__909f1288__"